import { getAppData } from "app/getAppData";
import {
  setPuzzelOrgConfig,
  setPuzzelRuntimeConfig,
} from "app/PuzzelAuth/puzzelAuthConfig";
import { Amplify } from "aws-amplify";

let isConfigured = false;

export const configureAuth = async (): Promise<void> => {
  if (isConfigured) {
    return;
  }

  const { authUrl, clientId, userPoolId, puzzel } = await getAppData();

  setPuzzelRuntimeConfig({
    clientId: puzzel.clientId,
    idpScheme: puzzel.idpScheme,
  });

  setPuzzelOrgConfig({
    ciqType: puzzel.ciqType,
    phoneNumberPrefix: puzzel.phoneNumberPrefix,
    functionalNumberPrefix: puzzel.functionalNumberPrefix,
    countryCode: puzzel.countryCode,
    maxAttempts: puzzel.maxAttempts,
    maxOneRequestForPreferredAgent: puzzel.maxOneRequestForPreferredAgent,
    preferredAgentWaitTimeSeconds: puzzel.preferredAgentWaitTimeSeconds,
    queueKey: puzzel.queueKey,
    reservedAgentWaitTimeSeconds: puzzel.reservedAgentWaitTimeSeconds,
    secondsBetweenAttempts: puzzel.secondsBetweenAttempts,
  });

  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            redirectSignIn: [`${window.location.origin}/login-redirect`],
            redirectSignOut: [`${window.location.origin}`],
            // Domain is set in terraform with https:// at the beginning, must be removed here to avoid double https in the URL
            domain: authUrl.replace("https://", ""),
            scopes: [],
            responseType: "code",
          },
        },
        userPoolId,
        userPoolClientId: clientId,
      },
    },
  });

  isConfigured = true;
};
